/**
 * Canonical event-bus / deep-link constants.
 * Lives under src/widget/ so the rollup widget bundle (rootDir=src/widget)
 * can import them. The React app re-exports these from src/config/deepLink.ts.
 */
export const DEEP_LINK_PARAM = 'property';
export const PARAM_PREFIX = 'twopoint-';
export const EVENT_PARAM = 'twopoint-event';
export const COMMAND_MESSAGE_TYPE = 'TWOPOINT_COMMAND';
